/*
 * Utility function that returns a category string from the query category
 */
export const getCategoryForStickyBanner = (
  categorySlug?: string | string[]
): string | undefined => {
  if (!categorySlug) {
    return;
  }

  if (Array.isArray(categorySlug) && categorySlug.length) {
    return categorySlug[0];
  }

  if (typeof categorySlug === 'string') {
    return categorySlug;
  }

  return;
};
